var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflowGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48353 3H4.37242C4.12696 3 3.92798 3.19898 3.92798 3.44444V6.55556C3.92798 6.80102 4.12696 7 4.37242 7H7.48353C7.72899 7 7.92798 6.80102 7.92798 6.55556V3.44444C7.92798 3.19898 7.72899 3 7.48353 3Z",
    stroke: "#565962",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4835 17H18.3724C18.127 17 17.928 17.199 17.928 17.4444V20.5556C17.928 20.801 18.127 21 18.3724 21H21.4835C21.729 21 21.928 20.801 21.928 20.5556V17.4444C21.928 17.199 21.729 17 21.4835 17Z",
    stroke: "#565962",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.928 19H7.92798C6.82341 19 5.92798 18.1046 5.92798 17V16V14C5.92798 12.8954 6.82341 12 7.92798 12H17.928C19.0325 12 19.928 11.1046 19.928 10V7C19.928 5.89543 19.0325 5 17.928 5H8.92798",
    stroke: "#565962",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowGrey);
export default __webpack_public_path__ + "static/media/workflow-grey.412e1a55dd312409029bba22bf928298.svg";
export { ForwardRef as ReactComponent };